export const compareValues = (val1, val2) => val1.toString() === val2.toString()
